// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required-star[data-v-55e28a1c]{color:red;font-weight:700}textarea[data-v-55e28a1c]{margin:1em auto;width:96%}img[data-v-55e28a1c]{max-width:-moz-max-content;max-width:max-content;width:100%;border-radius:4px}.image-preview[data-v-55e28a1c]{width:100px}.image-caption[data-v-55e28a1c]{display:inline-block}", ""]);
// Exports
module.exports = exports;
